<template>
  <div>
    <load-profile />
    <b-tabs
      v-model="activeTab"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
      @input="handleTabChange"
    >

      <b-tab
        v-if="$can('manage', 'manage-time-shift')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="BriefcaseIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.team')
          }}</span>
        </template>
        <team-list />
      </b-tab>
      <b-tab
        v-if="$can('manage', 'manage-employee')"
        lazy
      >
        <template #title>
          <feather-icon
            icon="UsersIcon"
            size="18"
            class="mr-50"
          />
          <span class="font-weight-bold">{{
            $t('breadcrumb.employee')
          }}</span>
        </template>
        <employee-list :department-id="$route.params.departmentId" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTab, BTabs,
} from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import TeamList from './TeamList.vue'
import EmployeeList from './TeamEmployeeList.vue'

const DepartmentRepository = Repository.get('department')

export default {
  components: {
    BTab,
    BTabs,
    TeamList,
    EmployeeList,
  },

  data() {
    return {
      activeTab: 0,
      permissionType: 'manage-team',
      tabMapping: {
        team: 0,
        employee: 1,
      },
    }
  },

  computed: {
    locale() {
      return this.$i18n.locale.split('-')[0]
    },
  },

  watch: {
    '$route.query.tab': {
      immediate: true,
      handler(newTab) {
        if (newTab && this.tabMapping[newTab] !== undefined) {
          this.activeTab = this.tabMapping[newTab]
          this.updateBreadcrumb(newTab)
        }
      },
    },
  },

  created() {
    const { tab } = this.$route.query
    if (tab && this.tabMapping[tab] !== undefined) {
      this.activeTab = this.tabMapping[tab]
    }
  },

  methods: {
    handleTabChange(newTab) {
      const tabNames = Object.keys(this.tabMapping)
      const newTabName = tabNames.find(key => this.tabMapping[key] === newTab)

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          tab: newTabName,
        },
      })

      this.updateBreadcrumb(newTabName)
    },

    updateBreadcrumb(tabName) {
      let breadcrumbText = 'breadcrumb.employee'

      if (tabName === 'team') {
        breadcrumbText = 'breadcrumb.team'
      } else if (tabName === 'employee') {
        breadcrumbText = 'breadcrumb.employee'
      }

      if (this.$route.meta.breadcrumb && this.$route.meta.breadcrumb.length > 0) {
        this.$route.meta.breadcrumb[this.$route.meta.breadcrumb.length - 1] = {
          text: breadcrumbText,
          active: true,
        }
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    if (!to.params.departmentId) {
      return next()
    }

    try {
      const response = await DepartmentRepository.show(to.params.departmentId)
      const data = response?.data?.data
      if (!data || !data.id) {
        // If no data or invalid data, redirect back to department list
        return next({ name: 'list-department' })
      }

      const getNameByLang = data => {
        const locale = localStorage.getItem('locale') || 'en'
        return data?.name?.[locale] || data?.name?.en || data?.name?.zh || data?.name?.vi || data?.name?.km
      }

      // Set breadcrumb if data exists
      to.meta.breadcrumb = [
        {
          text: typeof data?.name === 'string' ? data?.name : getNameByLang(data),
          to: { name: 'list-department' },
        },
        {
          text: 'breadcrumb.team',
          active: true,
        },
      ]

      next()
    } catch (error) {
      // Handle any errors by redirecting to department list
      console.error('Failed to fetch department:', error)
      next({ name: 'list-department' })
    }
  },
}
</script>
